import { CompanyMinifiedRowType } from '@api';
import { ActionsCell, AddressCell, ContactDetails } from '@common';
import { DataTableColumn } from 'mantine-datatable';
import { useTranslation } from 'react-i18next';

const TRANS_PATH = 'TABLE.COLUMNS';

type UseCompaniesOverviewTableColumnsPropsType = {
  handleDeleteCompany: (companyId: string) => void;
};

type UseCompaniesOverviewTableColumnsReturnType = {
  columns: DataTableColumn<CompanyMinifiedRowType>[];
};

export const useCompaniesOverviewTableColumns = ({
  handleDeleteCompany,
}: UseCompaniesOverviewTableColumnsPropsType): UseCompaniesOverviewTableColumnsReturnType => {
  const { t } = useTranslation('companies');

  const noDataPlaceholder = t('NO_DATA_PLACEHOLDER', { ns: 'common' });

  const columns: DataTableColumn<CompanyMinifiedRowType>[] = [
    {
      accessor: 'name',
      title: t(`${TRANS_PATH}.COMPANY_NAME`),
      sortable: true,
    },
    {
      accessor: 'address',
      title: t(`${TRANS_PATH}.HEADQUARTERS_ADDRESS`),
      render: ({ address }) => <AddressCell address={address} />,
    },
    {
      accessor: 'headquarters',
      title: t(`${TRANS_PATH}.HEADQUARTERS`),
      render: ({ headquarters }) => <ContactDetails contact={headquarters} />,
    },
    {
      accessor: 'tags',
      title: t(`${TRANS_PATH}.TAGS`),
      render: ({ tags }) => {
        if (!tags.length) {
          return noDataPlaceholder;
        }

        return tags.map((tag) => t(`TAGS.${tag}`)).join(', ');
      },
    },
    {
      accessor: 'actions',
      title: t(`${TRANS_PATH}.ACTIONS`),
      titleStyle: { textAlign: 'center' },
      render: (record) => (
        <ActionsCell.Root>
          <ActionsCell.Details to={`/companies/${record.id}/general`} />
          <ActionsCell.Delete onClick={() => handleDeleteCompany(record.id)} />
        </ActionsCell.Root>
      ),
      width: 100,
    },
  ];

  return { columns };
};
